export const ABORT = "ABORT";
export const AIRPLAYING_CHANGE = "AIRPLAYING_CHANGE";
export const CAN_AIRPLAY = "CAN_AIRPLAY";
export const CAN_PLAY = "CAN_PLAY";
export const CAN_PLAY_THROUGH = "CAN_PLAY_THROUGH";
export const CAPTION_CHANGE = "CAPTION_CHANGE";
export const CAPTION_TEXT_CHANGE = "CAPTION_TEXT_CHANGE";
export const DURATION_CHANGE = "DURATION_CHANGE";
export const EMPTIED = "EMPTIED";
export const END = "END";
export const END_SEEKING = "END_SEEKING";
export const ERROR = "ERROR";
export const LOAD_START = "LOAD_START";
export const LOADED_DATA = "LOADED_DATA";
export const LOADED_META_DATA = "LOADED_META_DATA";
export const PAUSE = "PAUSE";
export const PLAY = "PLAY";
export const PLAYING = "PLAYING";
export const PLAYLIST_POSITION_CHANGE = "PLAYLIST_POSITION_CHANGE";
export const PROGRESS_CHANGE = "PROGRESS_CHANGE";
export const RATE_CHANGE = "RATE_CHANGE";
export const RESIZE = "RESIZE";
export const SEEKED = "SEEKED";
export const SEEKING = "SEEKING";
export const SEEKING_TIME = "SEEKING_TIME";
export const STALLED = "STALLED";
export const SUSPEND = "SUSPEND";
export const TIME_UPDATE = "TIME_UPDATE";
export const USER_ACTIVITY = "USER_ACTIVITY";
export const VIEWMODE_CHANGE = "VIEWMODE_CHANGE";
export const VIEWMODE_FULLSCREEN_SLIDES_CHANGE =
  "VIEWMODE_FULLSCREEN_SLIDES_CHANGE";
export const VIEWMODE_FULLSCREEN_WINDOW_POSITION_CHANGE =
  "VIEWMODE_FULLSCREEN_WINDOW_POSITION_CHANGE";
export const VOLUME_CHANGE = "VOLUME_CHANGE";
export const WAITING = "WAITING";

export const CONTROLS_ACTIVE_SECONDS = 3;
export const DEFAULT_THROTTLE = 250;
export const LONG_SKIP_SECONDS = 30;
export const SHORT_SKIP_SECONDS = 15;
export const PLAYBACK_RATE_OPTIONS = [0.25, 0.5, 1, 1.25, 1.5, 1.75, 2];

export enum PlayState {
  PLAYING_PRE_ROLL,
  PLAYING_SESSION,
  PLAYING_POST_ROLL,
  ENDED,
}
